// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rs4R","tabsBox":"styles_tabsBox__XErC6","createButton":"styles_createButton__2D11U"};